import { jwtDecode } from "jwt-decode";

export const getCurrentUserFromJwt = () => {
    const decodedToken = jwtDecode(localStorage.getItem("accessToken") || "");
    return decodedToken;
};

export const removeCurrentUserFromJwt = () => {
    localStorage.removeItem("accessToken");
};
